import styled from 'styled-components';
import {
  Modal as SemanticModal,
  TextArea as SemanticTextArea,
  Form as FormSemantic,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)`

`;

const Container = styled.div`
  padding: 25px;
`;

const Title = styled(TextLayoutComponent.Title)``;

const ButtonSave = styled(ButtonLayoutComponent)``;

const ButtonCancel = styled(ButtonLayoutComponent.Inverted)``;

const ContainerBottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 15px;
`;

const TextArea = styled(SemanticTextArea)`
  &&& {
    height: 75px;
    resize: none;
  } 
`;

const Form = styled(FormSemantic)`
  &&& {
    padding: 15px 0 10px;
  }
`;

const FormField = styled(FormSemantic.Field)``;

export {
  Modal,
  Container,
  Title,
  ButtonSave,
  ButtonCancel,
  ContainerBottom,
  TextArea,
  Form,
  FormField,
};
